import React from 'react'

const ButtonShadow = ({ title, onClick, disabled }) => {
    return (
        <div className='text-center'>
            <button
                className='btn  btn-outline my-3 shadow rounded' 
                disabled={disabled} 
                onClick={onClick} 
            >{title}</button>
        </div>
    )
}

export default ButtonShadow
